/*
 * @Author: HTT httishere0728@gmail.com
 * @Date: 2024-09-03 22:16:55
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2024-09-03 23:06:57
 * @FilePath: /widverse-v2/src/pages/ReceiptCreator/form/xicha.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Input } from 'antd'
import FormItem from 'antd/es/form/FormItem'
export default function XichaForm() {
  return (
    <>
      <FormItem label="用户等级" name="orderClass">
        <Input placeholder="如：进阶贵宾" />
      </FormItem>
      <FormItem label="下单昵称" name="orderName">
        <Input placeholder="如：咖啡免费的啾啾" />
      </FormItem>
      <FormItem label="取餐编号" name="orderNumber">
        <Input placeholder="如：9877" />
      </FormItem>
      <FormItem label="订单商品" name="orderContent">
        <Input placeholder="如：多肉葡萄(首创)" />
      </FormItem>
      <FormItem label="客制化" name="orderCus">
        <Input placeholder="如：无奶油" />
      </FormItem>
      <FormItem label="订单模式" name="orderMode">
        <Input placeholder="如：外送 第1/2杯" />
      </FormItem>
      <FormItem label="说些什么" name="orderMessage">
        <Input placeholder="如：灵感常驻 清爽真果茶" />
      </FormItem>
      <FormItem label="下单店铺" name="orderStore">
        <Input placeholder="如：这里是店名" />
      </FormItem>
      <FormItem label="时间编码" name="orderTime">
        <Input placeholder="如：092-68103752  09.03 12:11" />
      </FormItem>
    </>
  )
}
